import axios from "axios";
import Vue from "vue";

const getDefaultSelectedUser = () => {
  return { duties: [{ unitId: null, roleIds: [], roleOptions: [], startDatetime: null, endDatetime: null }], employee: {}, birthdate: null, gender: null };
};

export default {
  state: () => ({
    user: {},
    loggedIn: false,
    userResources: [],
    selectedUser: getDefaultSelectedUser(),
    isThisAnUpdateUser: false,
    sidebarActiveClass: "anasayfa",
    showEmployees: { showEmployeesStatus: false },
    associatedStationId: 0,
    isFromCreatePageForUser: false,
    userPermissions: [],
    isPasswordReset: false,
    isItFromUserAccountDateListPage: false,
    accountDataListViewDates: { firstDate: null, secondDate: null },
    midnightRefreshFlag: false,
    selectedUserUnitId: null,
    parametersByUnit: 11,
    // selectedUserUnitId:null
  }),

  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setLoggedIn(state, loggedIn) {
      Vue.set(state, "loggedIn", loggedIn);
    },
    setUserResources(state, userResources) {
      Vue.set(state, "userResources", userResources);
    },
    setUserPermissions(state, userPermissions) {
      Vue.set(state, "userPermissions", userPermissions);
    },
    setSelectedUser(state, selectedUser) {
      Vue.set(state, "selectedUser", selectedUser);
    },
    setIsThisAnUpdateUser(state, isThisAnUpdateUser) {
      Vue.set(state, "isThisAnUpdateUser", isThisAnUpdateUser);
    },
    setSidebarActiveClass(state, sidebarActiveClass) {
      Vue.set(state, "sidebarActiveClass", sidebarActiveClass);
    },
    setShowEmployees(state, showEmployees) {
      Vue.set(state, "showEmployees", showEmployees);
    },
    setAssociatedStationId(state, associatedStationId) {
      Vue.set(state, "associatedStationId", associatedStationId);
    },
    setIsFromCreatePageForUser(state, isFromCreatePageForUser) {
      Vue.set(state, "isFromCreatePageForUser", isFromCreatePageForUser);
    },
    setIsPasswordReset(state, isPasswordReset) {
      Vue.set(state, "isPasswordReset", isPasswordReset);
    },
    setIsItFromUserAccountDateListPage(state, isItFromUserAccountDateListPage) {
      Vue.set(state, "isItFromUserAccountDateListPage", isItFromUserAccountDateListPage);
    },
    setAccountDataListView(state, accountDataListViewDates) {
      Vue.set(state, "accountDataListViewDates", accountDataListViewDates);
    },
    setMidnightRefreshFlag(state, midnightRefreshFlag) {
      Vue.set(state, "midnightRefreshFlag", midnightRefreshFlag);
    },
    setSelectedUserUnitId(state, selectedUserUnitId) {
      Vue.set(state, "selectedUserUnitId", selectedUserUnitId);
    },
    setParametersByUnit(state, parametersByUnit) {
      Vue.set(state, "parametersByUnit", parametersByUnit);
    },
    setDefaultSelectedUserUnitId(state, selectedUserUnitId) {
      Vue.set(state, "selectedUserUnitId", null);
    },
    setDefaultSelectedUser(state) {
      Vue.set(state, "user", {});
    },
    setDefaultUserModule(state) {
      Vue.set(state, "user", {});
      Vue.set(state, "loggedIn", false);
      Vue.set(state, "userResources", []);
      Vue.set(state, "selectedUser", getDefaultSelectedUser());
      Vue.set(state, "isThisAnUpdateUser", false);
      Vue.set(state, "sidebarActiveClass", "anasayfa");
      Vue.set(state, "showEmployees", { showEmployeesStatus: false });
      Vue.set(state, "associatedStationId", 0);
      Vue.set(state, "isFromCreatePageForUser", false);
      Vue.set(state, "userPermissions", []);
      Vue.set(state, "isPasswordReset", false);
      Vue.set(state, "isItFromUserAccountDateListPage", false);
      Vue.set(state, "accountDataListViewDates", { firstDate: null, secondDate: null });
      // Vue.set(state, "midnightRefreshFlag", false);
      Vue.set(state, "selectedUserUnitId", null);
      Vue.set(state, "parametersByUnit", 11);
    },
    // setSelectedUserUnitId(state, selectedUserUnitId){
    //     Vue.set(state,"selectedUserUnitId", selectedUserUnitId);
    // }
  },

  actions: {
    saveUserInformation: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/users", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    updateUserInformation: (context, request) => {
      return axios
        .put(context.getters.getMcServiceUrl + "/users", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    userLogin: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/user/login", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    userLogout: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/user/logout", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    refreshUserToken: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/user/refresh", request).then((response) => {
        return response.data;
      });
    },

    authorizeByUnit: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/user/authorize-by-unit", request)
        .then((response) => {
          // Her girişte (login + birim/kanal değişimi) oturum-içi "gösterildi" setini sıfırla;
          // böylece EVERY_LOGIN bilgilendirmeleri her login'de yeniden gösterilir.
          context.commit("resetShownStaffNotifications");
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadUsers: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/users/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUser: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/users/entity/" + request.id)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserStatusReason: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/user-status-reasons/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadUserFilterList: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/users/entity/list", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadUserGrantables: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/roles/grantables")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserGrantableUnits: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/roles/grantable-units")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserGrantableRoles: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/roles/grantable-roles", { params: { unitId: request } })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    resetPasswordGenerateCode: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/users/reset-password-generate-code", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    resetPassword: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/users/reset-password", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    sendEmailForActivision: (context, request) => {
      return axios
        .post(context.getters.getPoolExternalUrl + "/pex/notifications/send-email", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    userInformation: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/customers/reset-password-get-user", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    deleteUser: (context, request) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/users/" + request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserLog: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/logs" + request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadPersonalSales: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cases/personnel-sales-information", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserActions: (context, request) => {
      const params = {
        environment: "dev",
        userId: request,
      };

      return (
        axios
          // .get(context.getters.getMcServiceUrl + "/user-actions" +request)
          .get(context.getters.getMcServiceUrl + "/logs/user-actions", { params })
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadKkyUserEnrollmentNo: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/users/kky/" + request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserTypeForCustomer(context) {
      return axios.get(context.getters.getMcServiceUrl + "/user-status-reasons/by-user-type/customer").then((response) => {
        return response.data;
      });
    },
    loadUserTypeForUser(context) {
      return axios.get(context.getters.getMcServiceUrl + "/user-status-reasons/by-user-type/employee").then((response) => {
        return response.data;
      });
    },
    loadUserTicketReservations: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/purchase-histories/reservations/" + request.id)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getMco: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/purchase-histories/mco/" + request.identity)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    openTicketSearch: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/purchase-histories/open-tickets/" + request.identity)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadUserAccountDataReport: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/reports/user-account-data-report", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSalesReconciliationReport: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/reports/sales-reconciliation-report", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {
    getUser: (state) => {
      return state.user;
    },
    getLoggedIn: (state) => {
      return state.loggedIn;
    },
    getUserResources: (state) => {
      return state.userResources;
    },
    getSelectedUser: (state) => {
      return state.selectedUser;
    },
    getIsThisAnUpdateUser: (state) => {
      return state.isThisAnUpdateUser;
    },
    getSidebarActiveClass: (state) => {
      return state.sidebarActiveClass;
    },
    getShowEmployees: (state) => {
      return state.showEmployees;
    },
    getAssociatedStationId: (state) => {
      return state.associatedStationId;
    },
    getIsFromCreatePageForUser: (state) => {
      return state.isFromCreatePageForUser;
    },
    getUserPermissions: (state) => {
      return state.userPermissions;
    },
    getIsPasswordReset: (state) => {
      return state.isPasswordReset;
    },
    getIsItFromUserAccountDateListPage: (state) => {
      return state.isItFromUserAccountDateListPage;
    },
    getAccountDataListViewDates: (state) => {
      return state.accountDataListViewDates;
    },
    getMidnightRefreshFlag: (state) => {
      return state.midnightRefreshFlag;
    },
    getSelectedUserUnitId: (state) => {
      return state.selectedUserUnitId;
    },
    getParametersByUnit: (state) => {
      return state.parametersByUnit;
    },
    // getSelectedUserUnit: state => {
    //     return state.selectedUserUnit;
    // },
  },
};
